import { initialLogicalOperator } from '../constants';

const createNewTests = (arr) => (arr.length > 0 ? arr : null);

const createLogicOperator = (logicalOperator) => logicalOperator || initialLogicalOperator;

export { createNewTests, createLogicOperator };
